export default function (value = '') {
  let isValid

  const { path, createError } = this

  isValid =
    !value ||
    (value &&
      value.length > 0 &&
      (value.match(/^[\d]{2}$/) ||
        value.match(/^[\d]{2}\.[\d]{1,2}$/) ||
        value.match(/^[\d]{2}\.[\d]{1,2}\.[\d]{1,2}$/)))

  return (
    isValid ||
    createError({
      path,
      message:
        'services::forms.shared_fields.advertiser.fields.advertiser_info.okved_code.validation_messages.incorrect_format',
    })
  )
}
